// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateHouseholdV2Modal_SubBrandFragment = { __typename?: 'SubBrand', id: string, displayName: string };

export type CreateHouseholdV2ModalQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateHouseholdV2ModalQueryQuery = { __typename?: 'Query', subBrands: { __typename?: 'SubBrandConnection', edges?: Array<{ __typename?: 'SubBrandEdge', node?: (
        { __typename?: 'SubBrand', id: string }
        & CreateHouseholdV2Modal_SubBrandFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    CreateHouseholdV2ModalQuery: 'CreateHouseholdV2ModalQuery' as const
  },
  Fragment: {
    CreateHouseholdV2Modal_SubBrand: 'CreateHouseholdV2Modal_SubBrand' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CreateHouseholdV2Modal_SubBrandFragmentDoc = gql`
    fragment CreateHouseholdV2Modal_SubBrand on SubBrand {
  id
  displayName
}
    `;
export const CreateHouseholdV2ModalQueryDocument = gql`
    query CreateHouseholdV2ModalQuery {
  subBrands {
    edges {
      node {
        id
        ...CreateHouseholdV2Modal_SubBrand
      }
    }
  }
}
    ${CreateHouseholdV2Modal_SubBrandFragmentDoc}`;

/**
 * __useCreateHouseholdV2ModalQueryQuery__
 *
 * To run a query within a React component, call `useCreateHouseholdV2ModalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateHouseholdV2ModalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateHouseholdV2ModalQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateHouseholdV2ModalQueryQuery(baseOptions?: Apollo.QueryHookOptions<CreateHouseholdV2ModalQueryQuery, CreateHouseholdV2ModalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateHouseholdV2ModalQueryQuery, CreateHouseholdV2ModalQueryQueryVariables>(CreateHouseholdV2ModalQueryDocument, withFetchPolicyContext(options));
      }
export function useCreateHouseholdV2ModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateHouseholdV2ModalQueryQuery, CreateHouseholdV2ModalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateHouseholdV2ModalQueryQuery, CreateHouseholdV2ModalQueryQueryVariables>(CreateHouseholdV2ModalQueryDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCreateHouseholdV2ModalQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateHouseholdV2ModalQueryQuery, CreateHouseholdV2ModalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateHouseholdV2ModalQueryQuery, CreateHouseholdV2ModalQueryQueryVariables>(CreateHouseholdV2ModalQueryDocument, withFetchPolicyContext(options));
        }
export type CreateHouseholdV2ModalQueryQueryHookResult = ReturnType<typeof useCreateHouseholdV2ModalQueryQuery>;
export type CreateHouseholdV2ModalQueryLazyQueryHookResult = ReturnType<typeof useCreateHouseholdV2ModalQueryLazyQuery>;
export type CreateHouseholdV2ModalQuerySuspenseQueryHookResult = ReturnType<typeof useCreateHouseholdV2ModalQuerySuspenseQuery>;
export type CreateHouseholdV2ModalQueryQueryResult = Apollo.QueryResult<CreateHouseholdV2ModalQueryQuery, CreateHouseholdV2ModalQueryQueryVariables>;